export default "__VITE_ASSET__b4a3d38f__"